type DotProps = {
    active?: boolean;
    color: string;
};

export function Dot({ active = false, color }: DotProps) {
    return (
        <span
        className="inline-block h-4 w-4 rounded-full border"
        style={{
            borderColor: color,
            backgroundColor: active ? color : "transparent",
        }}
        aria-hidden="true"
        />
    );
}

type DotButtonProps = {
    active: boolean;
    color: string;
    label: string;
    onClick: () => void;
};

function DotButton({ active, color, label, onClick }: DotButtonProps) {
    return (
        <button
        type="button"
        onClick={onClick}
        aria-label={label}
        aria-current={active ? "page" : undefined}
        className="p-2 -m-2 rounded-full focus:outline-none focus-visible:ring-4"
        style={{ outlineColor: color }}
        >
        <Dot active={active} color={color} />
        </button>
    );
}

type PageDotsProps = {
  count?: number;
  color: string;
  currentIndex: number;
  sectionRefs: React.MutableRefObject<(HTMLElement | null)[]>;
  scrollOffsetPx?: number;
};

export function PageDots({
  count = 6,
  color,
  currentIndex,
  sectionRefs,
  scrollOffsetPx = 96,
}: PageDotsProps) {
  const scrollTo = (i: number) => {
    const el = sectionRefs.current[i];
    if (!el) return;

    const top = el.getBoundingClientRect().top + window.scrollY - scrollOffsetPx;

    window.scrollTo({
      top,
      behavior: "smooth",
    });
  };

  return (
    <div className="flex items-center gap-2" role="navigation" aria-label="Section navigation">
      {Array.from({ length: count }).map((_, i) => (
        <DotButton
          key={i}
          color={color}
          active={i === currentIndex}
          onClick={() => scrollTo(i)}
          label={`Jump to section ${i + 1}`}
        />
      ))}
    </div>
  );
}